import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const ItalicIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M18 5.07143C18 5.35559 17.8919 5.62811 17.6994 5.82904C17.5069 6.02997 17.2459 6.14286 16.9737 6.14286H14.2924L10.8714 16.8571H12.8684C13.1406 16.8571 13.4017 16.97 13.5941 17.171C13.7866 17.3719 13.8947 17.6444 13.8947 17.9286C13.8947 18.2127 13.7866 18.4853 13.5941 18.6862C13.4017 18.8871 13.1406 19 12.8684 19H6.02632C5.75412 19 5.49307 18.8871 5.3006 18.6862C5.10813 18.4853 5 18.2127 5 17.9286C5 17.6444 5.10813 17.3719 5.3006 17.171C5.49307 16.97 5.75412 16.8571 6.02632 16.8571H8.70757L12.1286 6.14286H10.1316C9.85938 6.14286 9.59834 6.02997 9.40586 5.82904C9.21339 5.62811 9.10526 5.35559 9.10526 5.07143C9.10526 4.78727 9.21339 4.51475 9.40586 4.31381C9.59834 4.11288 9.85938 4 10.1316 4H16.9737C17.2459 4 17.5069 4.11288 17.6994 4.31381C17.8919 4.51475 18 4.78727 18 5.07143Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props || $[2] !== ref) {
    t1 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}</svg>;
    $[1] = props;
    $[2] = ref;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
});
export default ItalicIcon;